var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import * as React from "react";
import { Icon, Spinner } from "office-ui-fabric-react";
import { TelemetryProvider, Applications, Components, Events } from "@iexpertsnl/analytics";
import { OfficeHostType } from "../interfaces/index";
import { TemplateSelection } from "./TemplatesPanel";
import { MetadataPanel } from "./MetadataPanel";
import { OfficeClientPanel } from "./OfficeClientPanel";
import { ErrorPanel } from "./ErrorPanel";
import { SuccessPanel } from "./SuccessPanel";
import "./styles.css";
import { DriveSelectionPanel } from "./DriveSelectionPanel";
var Panels;

(function (Panels) {
  Panels[Panels["Loading"] = 0] = "Loading";
  Panels[Panels["Host"] = 1] = "Host";
  Panels[Panels["Templates"] = 2] = "Templates";
  Panels[Panels["Drives"] = 3] = "Drives";
  Panels[Panels["Metadata"] = 4] = "Metadata";
  Panels[Panels["CopyFile"] = 5] = "CopyFile";
  Panels[Panels["Succes"] = 6] = "Succes";
  Panels[Panels["Failure"] = 7] = "Failure";
})(Panels || (Panels = {}));

var EasyTemplate =
/** @class */
function (_super) {
  __extends(EasyTemplate, _super);

  function EasyTemplate(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      isLoading: props.hostType != OfficeHostType.Unknown,
      templates: [],
      hostType: props.hostType,
      panelState: Panels.Loading,
      siteId: props.siteId,
      driveId: props.driveId,
      folderId: props.folderId,
      isLicensed: true,
      appInsights: undefined
    };
    return _this;
  }

  EasyTemplate.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var hasLicense, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this.props.client.GetLicense()];

          case 1:
            hasLicense = _a.sent();

            if (hasLicense) {
              this.setState({
                panelState: this.props.hostType == OfficeHostType.Unknown ? Panels.Host : Panels.Templates
              });
              this.loadTemplates();
            } else {
              this.setState({
                panelState: Panels.Failure,
                isLicensed: false
              });
            }

            return [3
            /*break*/
            , 3];

          case 2:
            err_1 = _a.sent();
            this.setState({
              panelState: Panels.Failure,
              isLicensed: false
            });
            return [3
            /*break*/
            , 3];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  EasyTemplate.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.hostType != this.props.hostType) {
      this.reset(this.props.hostType);
    }
  };

  EasyTemplate.prototype.reset = function (hostType) {
    if (!hostType) hostType = this.state.hostType; // no changes
    // reload available templates

    this.setState({
      templates: [],
      selectedTemplate: undefined,
      createdFile: undefined,
      hostType: hostType,
      folderId: this.props.folderId,
      driveId: this.props.driveId,
      siteId: this.props.siteId,
      isLoading: hostType != OfficeHostType.Unknown,
      panelState: hostType == OfficeHostType.Unknown ? Panels.Host : Panels.Templates
    }, this.loadTemplates.bind(this));
  };

  EasyTemplate.prototype.loadTemplates = function () {
    return __awaiter(this, void 0, void 0, function () {
      var promise, templates, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (this.state.panelState != Panels.Templates) return [2
            /*return*/
            ];

            switch (this.state.hostType) {
              case OfficeHostType.Word:
                promise = this.props.client.GetWordTemplates.bind(this.props.client);
                break;

              case OfficeHostType.Excel:
                promise = this.props.client.GetExcelTemplates.bind(this.props.client);
                break;

              case OfficeHostType.PowerPoint:
                promise = this.props.client.GetPowerPointTemplates.bind(this.props.client);
                break;

              default:
                promise = function promise() {
                  throw new Error("Unknown client");
                };

            }

            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , promise()];

          case 2:
            templates = _b.sent();
            this.setState({
              templates: templates,
              isLoading: false
            });
            return [3
            /*break*/
            , 4];

          case 3:
            _a = _b.sent();
            this.setState({
              isLoading: false,
              panelState: Panels.Failure
            });
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  EasyTemplate.prototype.selectHost = function (hostType) {
    var _this = this;

    this.setState({
      panelState: Panels.Templates,
      hostType: hostType
    }, function () {
      _this.reset(hostType);
    });
  }; // on select; show dialog for additional information (name, if not set; location, future: custom props?)


  EasyTemplate.prototype.selectTemplate = function (template) {
    if (!this.props.forceFolderSelection || this.state.siteId && this.state.driveId) {
      this.setState({
        panelState: Panels.Metadata,
        selectedTemplate: template
      });
    } else {
      this.setState({
        panelState: Panels.Drives,
        selectedTemplate: template
      });
    }
  };

  EasyTemplate.prototype.selectDrive = function (siteId, driveId, folderId) {
    this.setState({
      driveId: driveId,
      siteId: siteId,
      folderId: folderId,
      panelState: Panels.Metadata
    });
  }; // on accept, copy selected item to location with new name


  EasyTemplate.prototype.copyFile = function (source, target) {
    return __awaiter(this, void 0, void 0, function () {
      var result, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.setState({
              panelState: Panels.CopyFile
            });
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            if (this.state.appInsights) this.state.appInsights.track(Events.Click, "User copied template '" + source.title + "'");
            return [4
            /*yield*/
            , this.props.client.CopyFile(source, target)];

          case 2:
            result = _a.sent();

            if (result && result.webURL) {
              this.setState({
                panelState: Panels.Succes,
                createdFile: result
              });
              window.open(result.webURL); // open new file in other window

              return [2
              /*return*/
              ];
            }

            return [3
            /*break*/
            , 4];

          case 3:
            error_1 = _a.sent();
            return [3
            /*break*/
            , 4];

          case 4:
            this.setState({
              panelState: Panels.Failure
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  EasyTemplate.prototype.render = function () {
    var _this = this;

    var _a;

    var panel;
    var loadingText = this.props.strings.Loading.replace("{0}", this.props.strings.Templates);

    switch (this.state.panelState) {
      case Panels.Loading:
        panel = React.createElement(Spinner, {
          label: loadingText,
          className: "center"
        });
        break;

      case Panels.Host:
        panel = React.createElement(OfficeClientPanel, {
          selectHost: this.selectHost.bind(this),
          strings: this.props.strings
        });
        break;

      case Panels.Templates:
        if (this.state.isLoading) panel = React.createElement(Spinner, {
          label: loadingText,
          className: "center"
        });else panel = React.createElement(TemplateSelection, {
          selectTemplate: this.selectTemplate.bind(this),
          strings: this.props.strings,
          templates: this.state.templates,
          cancel: function cancel() {
            return _this.reset(OfficeHostType.Unknown);
          }
        });
        break;

      case Panels.Drives:
        panel = React.createElement(DriveSelectionPanel, {
          client: this.props.client,
          siteId: this.state.siteId,
          driveId: this.state.driveId,
          selectDrive: this.selectDrive.bind(this),
          strings: this.props.strings,
          cancel: function cancel() {
            return _this.reset();
          }
        });
        break;

      case Panels.Metadata:
        if (!this.state.selectedTemplate) {
          console.error("Can't show metadata for undefined selected template");
          panel = React.createElement(ErrorPanel, {
            buttonClick: this.reset.bind(this),
            message: this.props.strings.Error,
            buttonText: this.props.strings.Retry
          });
        } else {
          panel = React.createElement(MetadataPanel, {
            template: this.state.selectedTemplate,
            strings: this.props.strings,
            targetSiteId: this.state.siteId,
            targetDriveId: this.state.driveId,
            targetFolderId: this.state.folderId,
            cancel: function cancel() {
              return _this.reset();
            },
            copyFile: this.copyFile.bind(this)
          });
        }

        break;

      case Panels.CopyFile:
        panel = React.createElement(Spinner, {
          label: this.props.strings.CreatingFile,
          className: "center"
        });
        break;

      case Panels.Succes:
        panel = React.createElement(SuccessPanel, {
          webURL: (_a = this.state.createdFile) === null || _a === void 0 ? void 0 : _a.webURL,
          buttonClick: this.props.onClose,
          strings: this.props.strings
        });
        break;

      case Panels.Failure:
        panel = this.state.isLicensed ? React.createElement(ErrorPanel, {
          buttonClick: function buttonClick() {
            return _this.reset();
          },
          message: this.props.strings.Error,
          buttonText: this.props.strings.Retry
        }) : React.createElement(ErrorPanel, {
          message: this.props.strings.Unlicensed
        });
        break;
    }

    return React.createElement(TelemetryProvider, {
      application: Applications.EasyTemplate,
      component: Components.Main,
      after: function after(insights) {
        _this.setState({
          appInsights: insights
        });
      }
    }, React.createElement("div", {
      className: "templateContainer"
    }, React.createElement("div", {
      className: "title"
    }, React.createElement(Icon, {
      iconName: "Articles"
    }), " ", this.props.strings.Title), this.props.onClose && this.state.panelState != Panels.CopyFile && React.createElement("div", {
      className: "close",
      onClick: this.props.onClose,
      title: this.props.strings.Close
    }, React.createElement(Icon, {
      iconName: "ChromeClose"
    })), React.createElement("div", {
      className: "content"
    }, panel)));
  };

  return EasyTemplate;
}(React.Component);

export { EasyTemplate };